<template>
  <v-app>
    <v-navigation-drawer
            persistent
            :mini-variant="miniVariant"
            :clipped="clipped"
            v-model="drawer"
            enable-resize-watcher
            fixed
            app
    >
      <v-list dense>
        <v-list-group
                v-if="item.items"
                v-model="item.title === activeMenu"
                v-for="item in items"
                :key="item.title"
                :prepend-icon="item.action"
                no-action
        >
          <v-list-tile slot="activator">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
                  v-for="subItem in item.items"
                  :key="subItem.title"
                  @click="navigateTo(subItem.path)"
                  v-model="subItem.title === activeSubmenu"
          >
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>{{ subItem.action }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <v-list-tile
                v-else @click="navigateTo(item.path)"
                :key="item.title"
                v-model="item.title === activeMenu"
        >
          <v-list-tile-action>
            <v-icon>{{ item.action }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
            app
            :clipped-left="clipped"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

      <v-toolbar-title v-text="title"></v-toolbar-title>

      <v-spacer></v-spacer>

      <v-menu bottom offset-y v-if="isLoggedIn">
        <v-btn slot="activator" icon large>
          <v-avatar size="32px" tile>
            <img
              src="@/assets/1200px-User_font_awesome.png"
              alt="User"
            >
          </v-avatar>
        </v-btn>
        <v-list>
          <v-list-tile @click="logout">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-container fluid>
        <slot/>
      </v-container>
    </v-content>

    <v-footer :fixed="fixed" app>
      &nbsp; [{{ appEnvironment }}]
      <v-spacer></v-spacer>
      <span>&nbsp; &copy; 2018 Consnet. All rights reserved.</span>
    </v-footer>
  </v-app>
</template>

<script>
  import { mapState } from 'vuex';
  import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        clipped: true,
        drawer: true,
        fixed: false,
        items: [
          { action: 'dashboard', title: 'Home', path: { path: '/' } },
          {
            action: 'account_balance',
            title: 'Layouts',
            items: [
              { title: 'All Layouts', action: 'search', path: { path: '/layouts' } }
            ]
          },
          {
            action: 'event',
            title: 'Events',
            items: [
              { title: 'All Events', action: 'search', path: '/events' }
            ]
          },
          {
            action: 'settings',
            title: 'Settings',
            items: [
              { title: 'Seat Recommendation', action: 'event_seat', path: '/settings/seat-recommendation-rules' }
            ]
          }
        ],
        miniVariant: false,
        title: 'book•me'
      }
    },
    name: 'Default',
    computed: {
      appEnvironment() {
        return process.env.NODE_ENV;
      },
      /* map state from vuex */
      ...mapState([
        'activeMenu',
        'activeSubmenu',
      ]),
      ...mapGetters([
        'isLoggedIn'
      ])
    },
    methods: {
      navigateTo(path) {
        this.$router.push(path);
      },
      logout() {
        this.$store.dispatch('logout')
          .then(() => {
            this.navigateTo('/login');
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/appLayouts/Default.vue